export class AbstractScene extends Phaser.Scene {
    constructor() {
        super(...arguments);
        this.zoomScale = 1;
    }
    // gets called on each scene init automatically
    init() {
        if (window.innerWidth > 1100)
            this.zoomScale = 0.8;
        else
            this.zoomScale = 1;
        this.grs.setCamera(this, this.zoomScale);
    }
    /** The dimensions of entire display area */
    get resizeDim() {
        return { ...this.grs.gameResizeSize.get(this.scene.key) };
    }
    /** The dimensions of the design area (SAFE AREA) */
    get designDim() {
        return { ...this.grs.gameDesignSize };
    }
    attachHandlers() {
        this.handleResize();
        this.attachErrorHandlers();
    }
    turnOffResizeHandler() {
        this.game.scale.off('custom-resize', this.resizeHandler, this);
    }
    resizeHandler() {
        if (window.innerWidth > 1100)
            this.zoomScale = 0.8;
        else
            this.zoomScale = 1;
        this.grs.setCamera(this, this.zoomScale);
        this.resizeAndRepositionElements();
    }
    handleResize() {
        this.game.scale.on('custom-resize', this.resizeHandler, this);
    }
    attachErrorHandlers() {
        this.load.once('loaderror', () => {
            this.load.reset();
            this.load.removeAllListeners();
            alert('file load error');
        });
    }
}
